import React from 'react';
import { RouteProps } from 'react-router-dom';
import { demoPagesMenu, purdyPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import PurdyDefaultFooter from '../pages/_layout/_footers/CisDefaultFooter';

interface MenuItem {
	id: string;
	text: string;
	path: string;
	icon?: string;
	hide?: boolean;
	subMenu?: Menu | null;
}

interface Menu {
	[key: string]: MenuItem;
}

const generatePurdyRoutes = (menu: Menu) => {
	const routes: RouteProps[] = [];

	Object.keys(menu).forEach((key) => {
		const route = menu[key];

		if (route.path === menu.login.path || route.path === menu.forgot.path) {
			routes.push({ path: route.path, element: null });
		} else if (route.subMenu) {
			// Si el elemento tiene submenú, iterar en sus subelementos
			Object.keys(route.subMenu).forEach((subKey) => {
				const subRoute = route.subMenu![subKey];
				routes.push({ path: subRoute.path, element: <PurdyDefaultFooter /> });
			});
		} else {
			// Si no tiene submenú, agregar el path normal
			routes.push({ path: route.path, element: <PurdyDefaultFooter /> });
		}
	});

	return routes;
};

const purdyRoutes = generatePurdyRoutes(purdyPagesMenu);

const footers: RouteProps[] = [
	...purdyRoutes,
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: demoPagesMenu.login.path, element: null },
	{ path: demoPagesMenu.signUp.path, element: null },
	{ path: demoPagesMenu.page404.path, element: null },
	{ path: demoPagesMenu.knowledge.subMenu.grid.path, element: null },
	{ path: '*', element: <PurdyDefaultFooter /> },
];

export default footers;
